const currencyFormatter = new Intl.NumberFormat('en-IN', {
  style: 'currency',
  currency: 'INR',
  maximumFractionDigits: 0,
});

export const formatCurrency = (value = 0) => currencyFormatter.format(Number(value || 0));

export const getBarHeight = (value = 0, maxValue = 0) => {
  if (!maxValue) return 0;
  return Math.max(0, Math.min(100, (Number(value || 0) / Number(maxValue)) * 100));
};
